import type { ReactNode } from 'react';

// Stands where buying links for a Chanel product would otherwise appear.
export function ChanelDisclosure({
  compact = false,
  className = '',
  children,
}: {
  compact?: boolean;
  className?: string;
  children?: ReactNode;
}) {
  const notice = (
    <p>
      Identifrag is an independent fragrance comparison engine. We are not affiliated with Chanel,
      do not represent Chanel, and do not sell Chanel products. Chanel trademarks, logos and bottle
      designs are the property of Chanel.
    </p>
  );

  if (compact) {
    return (
      <div className={'preview-buying chanel-disclosure ' + className}>
        <h4 className="preview-buying-label">Independent comparison</h4>
        {notice}
        {children && <div className="preview-actions">{children}</div>}
      </div>
    );
  }

  return (
    <section className={'chanel-disclosure ' + className} aria-label="Chanel independence disclosure">
      <h2>Independent comparison</h2>
      {notice}
    </section>
  );
}
